module.exports = __webpack_public_path__ + "static/melissa-strong-57b83887d7c76172dced68752e52f2e9.jpg";